export const handleChangeData = (value, set) => {
    let data = new Date(value)
    try {
        set(data.toISOString().slice(0, 10))
    } catch (e) {
        set(value)
    }
}